import React from 'react';
import NoDataFound from '../../../component/noDataComponent/NoDataFound';

function LinkedCustomersTable({ customers }) {
  return (
    <div className="linked-customers-section">
      <div className="tabledata">
        {customers?.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th className="tablesth">S.No</th>
                <th className="tablesth">Customer Name</th>
                <th className="tablesth">Customer Code</th>
                <th className="tablesth">Mobile Number</th>
                <th className="tablesth">APS Code</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer, index) => (
                <tr key={index}>
                  <td className="tabletd-pgmlist">{index + 1}</td>
                  <td className="tabletd-pgmlist">{customer.customer_name}</td>
                  <td className="tabletd-pgmlist">{customer.customer_code}</td>
                  <td className="tabletd-pgmlist">{customer.mobile_number}</td>
                  <td className="tabletd-pgmlist">{customer.aps_code}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoDataFound />
        )}
      </div>
    </div>
  );
}

export default LinkedCustomersTable;
